import {Injectable, inject} from '@angular/core';

import {
  FeedbackAndAnalyticsResolver,
  FeedbackAndAnalyticsService,
} from 'frontend/services/feedback_and_analytics_service';
import {UserScopeService} from 'frontend/services/user_scope_service';

/**
 * GPT-T Feedback And Analytics Service
 */
@Injectable({providedIn: 'root'})
export class GPTTFeedbackAndAnalyticsService extends FeedbackAndAnalyticsService {
  override userScope = inject(UserScopeService);
  override resolver = new FeedbackAndAnalyticsResolver('gpt-t');
  constructor() {
    super();
  }
}
